var styles = {
  "RecurringPaymentTextField": "DiscountAppComponents-UsageLimitsCard-RecurringPayment__RecurringPaymentTextField"
};

export { styles as default };
